class RecentlyProducts extends HTMLElement {
  constructor() {
    super();
    this.ul = null;
  }

  connectedCallback() {
    this.ul = this.querySelector('ul');
    if (!this.ul) return;
    this.loadAndRender();
  }

  async loadAndRender() {
    const handles = JSON.parse(localStorage.getItem('recentlyViewed') || '[]').reverse().slice(0, 4);

    for (const handle of handles) {
      try {
        const res = await fetch(`/products/${handle}.js`);
        if (!res.ok) continue;
        const product = await res.json();
        const li = this._buildListItem(product);
        this.ul.appendChild(li);
      } catch (err) {
        console.error('RecentlyViewedProducts error for', handle, err);
      }
    }
  }

  _buildListItem(product) {
    // Media URLs (video or images)
    let imageBase_1 = '';
    let imageBase_2 = '';
    let widths = [];
    let srcset = '';
    let src = '';
    let secondSrc = '';
    let hasVideo = false;
    let videoSrc = '';
    let videoPreviewImage = '';

    // Check if first media is video
    if (product.media && product.media.length > 0 && product.media[0].media_type === 'video') {
      hasVideo = true;
      
      // Find the best quality video source (prefer 1080p HD)
      const sources = product.media[0].sources || [];
      let bestSource = sources[0]; // fallback to first source
      
      // Look for 1080p HD mp4 source first
      const hd1080Source = sources.find(source => 
        source.height === 1080 && source.format === 'mp4'
      );
      
      // If no 1080p, look for 720p HD mp4 source
      const hd720Source = sources.find(source => 
        source.height === 720 && source.format === 'mp4'
      );
      
      // Use the best available source
      if (hd1080Source) {
        bestSource = hd1080Source;
      } else if (hd720Source) {
        bestSource = hd720Source;
      }
      
      videoSrc = bestSource?.url || '';
      videoPreviewImage = product.media[0].preview_image?.src || '';
      
      // Use video preview as primary image and find next non-duplicate image for secondary
      imageBase_1 = videoPreviewImage?.split('?')[0] || '';
      imageBase_2 = product.images.find(image => image?.split('?')[0] !== imageBase_1)?.split('?')[0] || '';
      widths = [165, 360, 533, 720, 940];
      srcset = widths.map(width => `${imageBase_1}?width=${width} ${width}w`).join(',');
      src = `${imageBase_1}?width=533`;
      secondSrc = `${imageBase_2}?width=533`;
    }
    else {
      imageBase_1 = product.images[0]?.split('?')[0] || '';
      imageBase_2 = product.images[1]?.split('?')[0] || '';
      widths = [165, 360, 533, 720, 940];
      srcset = widths.map(width => `${imageBase_1}?width=${width} ${width}w`).join(',');
      src = `${imageBase_1}?width=533`;
      secondSrc = `${imageBase_2}?width=533`;
    }

    // Pricing
    const price = (product.price / 100).toFixed(2);
    const compareMax = product.compare_at_price_max;
    const compare = compareMax ? (compareMax / 100).toFixed(2) : null;
    const savePct = compareMax ? Math.round((1 - product.price / compareMax) * 100) : 0;

    // Detect options
    const opts = product.options.map(o => o.name.toLowerCase());
    const onlyColour = opts.length === 1 && opts[0] === 'colour';

    // Size variants HTML
    let variantsHTML = '';
    if (!onlyColour) {
      variantsHTML = `
        <div class="variant-selector__choices-wrapper-container">
          <div class="variant-selector__choices-wrapper">
            ${product.variants.map(variant => `
              <div class="variant-selector__choice"
                   data-color="${variant.option2}"
                   data-product-id="${product.id}"
                   style="display:flex;">
                <button class="variant-selector__item"
                        aria-label="${variant.title}"
                        data-variant-id="${variant.id}"
                        data-inventory-quantity="${variant.inventory_quantity}">
                  <span class="variant-selector__text">${variant.option1}</span>
                </button>
              </div>
            `).join('')}
          </div>
          <div class="variant-selector__choices-wrapper-error_message">
            <span class="svg-wrapper">
              <svg class="icon icon-error" viewBox="0 0 13 13">
                <circle cx="6.5" cy="6.5" r="5.5" stroke="#fff" stroke-width="2"/>
                <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width=".7"/>
                <path fill="#fff" d="m5.874 3.528 .1 4.044 h1.053 l.1 -4.044"/>
                <path fill="#fff" stroke="#EB001B" stroke-width=".7"
                      d="M5.874 3.178 h-.359 l.01.359 .1 4.044 .008.341 h1.736 .008-.341 .1-4.044 .01-.359 z"/>
              </svg>
            </span>
            <span class="variant-selector__error-message"></span>
          </div>
        </div>
      `;
    }

    // Quick-add HTML
    let quickAddHTML = '';
    if (onlyColour) {
      const colorOption = product.options.find(option => option.name.toLowerCase() === 'colour');
      const colors = colorOption?.values || [];
      quickAddHTML = `
        <quick-add data-product-id="${product.id}" data-loading-icon="/cdn/shop/t/83/assets/fx-loading-icon.svg?v=1" data-is-preorder="false">
            <div class="color__swatch" id="quick-add-template--${product.id}">
                <div class="color__swatch-header">
                    <p class="mobile-quick-add-title">select colour:&nbsp;<span class="value-name">${colors[0] || ''}</span></p>
                    <a class="mobile-quick-add-clsBtn"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="#000" d="M.865 15.978a.5.5 ..."/></svg></a>
                </div>
            </div>
            <div class="quick__add desktop_quick_add_button" data-product-id="${product.id}" id="quick-add-template--${product.id}">
                <div class="variant-selector__choices-wrapper-container">
                <button class="variant-selector__item product-form__submit button button--full-width" aria-label="Add to cart" data-variant-id="${product.variants[0]?.id || ''}" data-inventory-quantity="${product.variants[0]?.inventory_quantity || 0}">
                    <span>Add to cart</span>
                    <div class="loading__spinner hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg>
                    </div>
                </button>
                </div>
                ${colors.length ? `
                <div class="product-colour__items" role="radiogroup">
                ${colors.map((color, idx) => {
        const variant = product.variants.find(v => v.option2 === color) || {};
        const selected = idx === 0 ? ' selected-color' : '';
        return `
                    <a class="swatch${selected} swatch__hex" data-swatch-name="${color}" data-color="${color}" data-color-value="${color}" data-product-id="${product.id}" data-variant-id="${variant.id || ''}" data-variant-inventory="${variant.inventory_quantity || 0}" role="radio" aria-checked="${idx === 0}" aria-label="${color}" title="${color}">
                        <span class="color-swatch fx-col-${color.toLowerCase().replace(/\//g, '_').replace(/\s/g, '-')}"></span>
                    </a>
                    `;
      }).join('')}
                </div>
                ` : ''}
            </div>
            <div class="mobileQuickAdd-btn">
                <button class="variant-selector__item mobileAddCart product-form__submit button button--full-width" aria-label="Add to cart" data-variant-id="${product.variants[0]?.id || ''}" data-inventory-quantity="${product.variants[0]?.inventory_quantity || 0}">
                <span>Add to cart</span>
                <div class="loading__spinner hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg>
                </div>
                </button>
            </div>
        </quick-add>
      `;
    } else {
      const colours = [...new Set(product.variants.map(variant => variant.option2))].filter(color => color);
      let colorSwatchHTML = '';
      if (colours.length) {
        const firstColor = colours[0];
        const firstVariant = product.variants.find(v => v.option2 === firstColor) || {};
        const imgLink = firstVariant.featured_image?.src || secondSrc;
        colorSwatchHTML = `
          <div class="color__swatch" id="quick-add-template--${product.id}">
            <div class="color__swatch-header">
              <p class="mobile-quick-add-title">select colour:&nbsp;<span class="value-name">${firstColor}</span></p>
              <a class="mobile-quick-add-clsBtn"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="#000" d="M.865 15.978a.5.5 ..."/></svg></a>
            </div>
            <div class="product-colour__items" role="radiogroup">
              ${colours.map(color => {
          const v = product.variants.find(v => v.option2 === color) || {};
          const sImg = v.featured_image?.src || imgLink;
          const sel = color === firstColor ? ' selected-color' : '';
          return `
                  <a class="swatch${sel} swatch__hex" data-swatch-name="${color}" data-color="${color}" data-color-value="${color}" data-product-id="${product.id}" data-variant-id="${v.id || ''}" data-variant-inventory="${v.inventory_quantity || 0}" role="radio" aria-checked="${color === firstColor}" aria-label="${color}" title="${color}">
                    <span class="color-swatch fx-col-${color.toLowerCase().replace(/\//g, '_').replace(/\s/g, '-')}" data-variant-image-link="${sImg}"></span>
                  </a>
                `;
        }).join('')}
            </div>
          </div>
        `;
      }
      quickAddHTML = `
        <quick-add data-product-id="${product.id}" data-loading-icon="/cdn/shop/t/83/assets/fx-loading-icon.svg?v=1" data-is-preorder="false">
          <div class="quick__add" data-product-id="${product.id}" id="quick-add-template--${product.id}">
            <div class="size__swatch-header"><span class="mobile-quick-add-title">select size:</span></div>
            ${variantsHTML}
          </div>
          ${colorSwatchHTML}
        </quick-add>
      `;
    }

    // Build LI
    const li = document.createElement('li');
    li.className = 'grid__item';
    li.innerHTML = `
      <link href="/cdn/shop/t/83/assets/component-rating.css" rel="stylesheet" media="all">
      <link href="/cdn/shop/t/83/assets/component-volume-pricing.css" rel="stylesheet" media="all">
      <link href="/cdn/shop/t/83/assets/component-price.css" rel="stylesheet" media="all">
      <link href="/cdn/shop/t/83/assets/quick-order-list.css" rel="stylesheet" media="all">
      <link href="/cdn/shop/t/83/assets/quantity-popover.css" rel="stylesheet" media="all">
      <link href="/cdn/shop/t/83/assets/component-fx-colour-swatch.css" rel="stylesheet" media="all">
      <link href="/cdn/shop/t/83/assets/swatch-colours.css" rel="stylesheet" media="all">

      <div class="card-wrapper product-card-wrapper underline-links-hover">
        <div class="card card--standard card--media" style="--ratio-percent:150%;">
          <div class="card__inner color-scheme-1 gradient ratio" style="--ratio-percent:150%;">
            <div class="card__media">
              <div class="media media--transparent media--hover-effect">
                ${hasVideo ? `
                <a href="/products/${product.handle}">
                  <video muted loop playsinline class="motion-reduce" poster="${videoPreviewImage}" id="product-video-${product.id}">
                    <source src="${videoSrc}" type="video/mp4">
                    <img srcset="${srcset}" src="${src}"
                         sizes="(min-width:1900px)442px,(min-width:990px)calc((100vw-130px)/4),(min-width:750px)calc((100vw-120px)/3),calc((100vw-35px)/2)"
                         alt="${product.title}" loading="lazy" class="motion-reduce">
                  </video>
                  <script>
                    const videoElement = document.getElementById('product-video-${product.id}');
                    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                      videoElement.setAttribute('autoplay', '');
                      videoElement.play();
                    }
                  </script>
                </a>
                ` : `
                <a href="/products/${product.handle}">
                  <img srcset="${srcset}" src="${src}"
                       sizes="(min-width:1900px)442px,(min-width:990px)calc((100vw-130px)/4),(min-width:750px)calc((100vw-120px)/3),calc((100vw-35px)/2)"
                       alt="${product.title}" loading="lazy" class="motion-reduce">
                </a>
                `}
                <a href="/products/${product.handle}">
                  <img src="${secondSrc}"
                       alt="${product.title} - secondary"
                       loading="lazy" class="motion-reduce">
                </a>
              </div>
            </div>

            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading">
                  <a href="/products/${product.handle}" class="full-unstyled-link">${product.title}</a>
                </h3>
              </div>
            </div>

            <a class="product-quick-add__button"
               data-product-id="${product.id}"
               data-loading-icon="/cdn/shop/t/83/assets/fx-loading-icon.svg"
               data-is-preorder="false">
              <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 483.1 483.1" xml:space="preserve" class="quick_add_cart_icon">
                <g>
                  <path d="M434.55,418.7l-27.8-313.3c-0.5-6.2-5.7-10.9-12-10.9h-58.6c-0.1-52.1-42.5-94.5-94.6-94.5s-94.5,42.4-94.6,94.5h-58.6
                    c-6.2,0-11.4,4.7-12,10.9l-27.8,313.3c0,0.4,0,0.7,0,1.1c0,34.9,32.1,63.3,71.5,63.3h243c39.4,0,71.5-28.4,71.5-63.3
                    C434.55,419.4,434.55,419.1,434.55,418.7z M241.55,24c38.9,0,70.5,31.6,70.6,70.5h-141.2C171.05,55.6,202.65,24,241.55,24z
                     M363.05,459h-243c-26,0-47.2-17.3-47.5-38.8l26.8-301.7h47.6v42.1c0,6.6,5.4,12,12,12s12-5.4,12-12v-42.1h141.2v42.1
                    c0,6.6,5.4,12,12,12s12-5.4,12-12v-42.1h47.6l26.8,301.8C410.25,441.7,389.05,459,363.05,459z"></path>
                </g>
              </svg>
            </a>
          </div>

          <div class="card__content product__info">
            <div class="card__information">
              ${compare ? `<span class="saving-persentage price-item--sale">Save ${savePct}%</span>` : ''}
              <h3 class="card__heading h5">
                <a href="/products/${product.handle}" class="full-unstyled-link">${product.title}</a>
              </h3>
              <div class="card-information"
                   data-product-type="${opts.join(',')}"
                   data-product-compare-at-price="${!!compare}">
                <div class="price price--on-sale">
                  <div class="price__container">
                    ${compare ? `
                      <div class="price__regular">
                        <span class="visually-hidden">Regular price</span>
                        <span class="price-item price-item--regular">$${compare}</span>
                      </div>
                    ` : ''}
                    <div class="price__sale">
                      <span class="price-item price-item--sale price-item--last">$${price}</span>
                      <span>
                      ${compare ? `<s class="price-item price-item--regular">$${compare}</s>` : ''}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              ${quickAddHTML}
            </div>
          </div>
        </div>
      </div>
    `;
    return li;
  }
}

customElements.define('recently-viewed-products', RecentlyProducts);